module.exports = "<div ng-if=\"HousingAssociationCtrl.dataFromBackendForDisplayName\">\n    <im-upper-header user-type=\"'housing_association'\"></im-upper-header>\n    <div class=\"lane-contractor\"></div>\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-md-12 nopaddings\">\n                <div class=\"content-container\" ui-view></div>\n            </div>\n        </div>\n        <im-footer url-bug-report=\"'inhabitant.bug_report'\"></im-footer>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/_housing_association/housing_association.html
// module id = 499
// module chunks = 0